import { mainLogger as log } from "@/app/logger"
import { SessionStorage } from "@/app/storage"
import { isObjectWithProps, isStringNotEmpty } from "@/app/utils"

// absolute path on the current host - works for both preview URLs and production URLs
const TOKEN_URL = `/api/token`
export const API_TOKEN_SESSION_KEY = "apiToken"
const HEADERS = {
  Accept: "application/json",
  "Content-Type": "application/json",
}
const GET = { headers: HEADERS, method: "GET" }
const GRAF_TOKEN_EXPIRY_SEC = 3600 // 1hr

export async function getToken(): Promise<string> {
  const apiToken: string = SessionStorage.get(API_TOKEN_SESSION_KEY)

  log.debug("Checking for existing API token in Session", apiToken)
  if (apiToken && SessionStorage.isAvailable()) {
    log.debug("Returning API token", apiToken, "from Session")
    return apiToken
  }

  log.info("Getting new API token from backend", TOKEN_URL)
  return fetch(`${TOKEN_URL}`, GET)
    .then(async (response) => {
      const statusMessage = `code:${response.status}(${response.statusText}), type:${response.type}`
      if (!response.ok) {
        log.error("Fetch API error in", TOKEN_URL, "with", statusMessage)
        return null // dont propagate the error, return null
      }
      const responseJson = await response.json()

      // check that API response has the property "token" and its value is non-empty String
      if (
        isObjectWithProps(responseJson, "token") &&
        isStringNotEmpty(responseJson.token)
      ) {
        const apiToken = responseJson.token
        const expiresAt = Date.now() + GRAF_TOKEN_EXPIRY_SEC * 1000
        log.info("Saving new API token", apiToken, "with expiry at", expiresAt)
        SessionStorage.set(API_TOKEN_SESSION_KEY, apiToken, expiresAt)
        return apiToken
      }
      log.error("Could not load API token from:", responseJson)
      return null
    })
    .catch((error) => {
      log.error("Error in", TOKEN_URL, "as", error)
      return null // dont propagate the error, return null
    })
}
